<app-list-header [headerName]="headerName"></app-list-header>

<div class="analysis-all-list">
  <app-lessons-list
    [lessonStatus]="lesson_completed"
    [showHeader]="false"
    [onlyStatuses]="[lesson_completed, lesson_completed_not_final]">
  </app-lessons-list>
</div>